<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-29 11:21:00
 * @Description: 
-->
<template>
    <span class="auto-tip"
        @click="visibleControl"
    >
        <IconSvgUse use="icon-info" /> 
    </span>
    <!-- 
        ↑ 图标 ℹ️
        ↓ 弹出窗口
    --> 
    <ModalAutoModeReminder 
        style="text-align: left;"
        v-model="bReminderVisible" 
        :onPurpose="bSeeOnPurpose"
        :gameName="gameName"
    />
</template>

<script setup>
const props = defineProps({
    size: {
        type: String,
        default: '16px',
    },
    gameName: String,
});
const bSeeOnPurpose = ref(false); // 用户有意查看，
const bReminderVisible = ref(false); // 控制可见性 

function visibleControl(){
    bSeeOnPurpose.value = true;
    bReminderVisible.value = true;
}

watch(bReminderVisible, (newValue)=>{
    if (!newValue) {
        // 窗口关闭时还原此值，以使下次打开时不出错 
        bSeeOnPurpose.value = false; 
    }
});

defineExpose({
    bReminderVisible, // 用于父组件修改窗口可见性
});

</script>

<style scoped lang="scss">
.auto-tip{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #263041;
    border: 1px solid #55657e;
    border-radius: 50%;
    margin-left: 7px;
    padding: 0;
    pointer-events: auto;
    height: v-bind('size');
    width: v-bind('size');
    cursor: pointer;
    color: var(--color_grey-20);
    svg{
        width: calc(v-bind('size') * 0.65);
        height: calc(v-bind('size') * 0.65);
        line-height: calc(v-bind('size') * 0.65);
    }
    &:hover{
        color: white;
    }
}

</style>

